import type { JSX } from 'react';

import type { ErrorHandlerProps } from 'src/app/pages/about/impact/pageContext';

export function ImpactErrorHandler({ context: { error } }: ErrorHandlerProps): JSX.Element {
	throw new Error(`Failed to retrieve data for Impact page (error: ${error})`);
}
